import { withRouter } from 'react-router-dom';
import SessionDetails from './SessionDetails';

export default withRouter(SessionDetails);
